/**
 * A remapped clock for a film whose opening runs slower than it was cut.
 *
 * The opening (frames 0..c0 of the film) is stretched to 0..c1 of the output, and everything after
 * it is the same film, shifted later by (c1 - c0). `w` maps an output frame to the film's frame (for
 * `<Freeze frame={w(f)}>`, which takes a fractional frame), `inv` maps a film frame to the output
 * (for the effect cues, through the SfxWarp context in ./brand.tsx), `extra` is how much longer the
 * output is.
 */
export type Warp = { w: (f: number) => number; inv: (at: number) => number; extra: number };

export const makeWarp = (c0: number, c1: number): Warp => ({
	w: (f) => (f < c1 ? (f * c0) / c1 : f - (c1 - c0)),
	inv: (at) => (at < c0 ? (at * c1) / c0 : at + (c1 - c0)),
	extra: c1 - c0,
});
